/**
 * Utilidad para realizar peticiones fetch con reintentos automáticos
 * @param {string} url - URL de la petición
 * @param {Object} options - Opciones del fetch
 * @param {Object} retryConfig - Configuración de reintentos
 * @returns {Promise<Response>}
 */
export const fetchWithRetry = async (url, options = {}, retryConfig = {}) => {
    const { 
        maxRetries = 3, 
        delay = 1000, 
        retryOnCodes = [500, 502, 503, 504] 
    } = retryConfig;

    let lastError;

    for (let i = 0; i <= maxRetries; i++) {
        try {
            const response = await fetch(url, options);

            // Si la respuesta es exitosa o no está en los códigos de reintento, retornar
            if (response.ok || !retryOnCodes.includes(response.status)) {
                return response;
            }

            console.warn(`Petición fallida (${response.status}). Reintento ${i + 1}/${maxRetries}...`);
            lastError = new Error(`HTTP_ERROR_${response.status}`);
        } catch (error) {
            console.warn(`Error de red en petición. Reintento ${i + 1}/${maxRetries}...`, error);
            lastError = error;
        }

        if (i < maxRetries) {
            // Espera exponencial básica o fija
            await new Promise(resolve => setTimeout(resolve, delay * Math.pow(2, i)));
        }
    }

    throw lastError;
};
